import React from 'react';
import PropTypes from 'prop-types';

const RadioButtonOption = ({ name, value, selected, label }) => (
    <div className="radio-button">
        <input type="radio" id={value} name={name} value={value} checked={selected} />
        <label className="login-radio" htmlFor={value}>
            {label}
        </label>
    </div>
);

RadioButtonOption.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
};

RadioButtonOption.displayName = 'RadioButtonOption';

export default RadioButtonOption;
